"use client";

import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { useEffect, useState } from "react";
import { getSoldListings } from "../../firebase/sales";
import { formatDate } from "../../utils";

export default function DialogSales({
    open,
    onClose,
    user
}) {
    const [sales, setSales] = useState([])

    useEffect(() => {
        getSoldListings(user.id).then(data => {
            setSales(data)
        })
    }, [user])

    return (
        <Dialog open={open} onClose={onClose} className="relative z-[10001]">
            <DialogBackdrop
                transition
                className="fixed inset-0 bg-[#000] backdrop-blur-sm bg-opacity-75 transition-opacity"
            />

            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4 sm:p-0">
                    <DialogPanel
                        transition
                        className="relative transform overflow-hidden w-[550px] bg-[#141414] backdrop-blur-sm shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in  rounded-[15px]"
                    >
                        <div className="w-full flex flex-col relative p-6">
                            <div className="flex justify-between">
                                <div className="flex">
                                    <span className="text-primary text-[28px]">Sale History</span>
                                </div>

                                <button
                                    onClick={onClose}
                                    className="top-2 right-2 cursor-pointer z-[1]"
                                >
                                    <img
                                        src="/assets/icons/icon-close.svg"
                                        alt="Close"
                                        className="invert cursor-pointer"
                                    />
                                </button>
                            </div>

                            <div className="mt-7">
                                <div className="text-xs">
                                    <div className="mt-2 mb-2">
                                        <span className="text-primary">Recent Sales</span>
                                    </div>

                                    <div className="text-[#767676] font-light w-full">
                                        <div className="bg-white flex rounded-[6px] w-full relative h-[28px]">
                                            <div className="absolute left-1 font-thin py-1 pl-3 overflow-hidden text-start  top-[50%] -translate-y-1/2">
                                                Title
                                            </div>
                                            <div className="absolute left-[40%] -ml-1 font-thin py-1 text-start  top-[50%] -translate-y-1/2">
                                                Sale Date
                                            </div>
                                            <div className="absolute left-[70%] -ml-2 font-thin py-1 overflow-hidden text-start  top-[50%] -translate-y-1/2">
                                                Sale Amount
                                            </div>
                                        </div>

                                        <div className="max-h-[200px] overflow-auto mt-1 mb-8">
                                            {
                                                sales.length > 0 ?
                                                    sales.map((item, index) =>
                                                        <div key={`withdraw-${index}`} className="flex relative w-full h-[35px] rounded-[6px]">
                                                            <div className="absolute left-1 top-[50%] -translate-y-1/2 py-3 pl-4">
                                                                {item.listing_title}
                                                            </div>
                                                            <div className="absolute  left-[40%]  top-[50%] -translate-y-1/2">
                                                                {formatDate(item.created_at.seconds)}
                                                            </div>
                                                            <div className="absolute left-[70%] top-[50%] -translate-y-1/2">
                                                                $ {item.price.toFixed(2)}
                                                            </div>
                                                        </div>
                                                    ) :
                                                    <div className="text-center w-full mt-2 -ml-3">
                                                        No sales history
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    );
}
